import { Navigate, Outlet } from "react-router";
import { usePortalSettings } from "../api/hooks/usePortalSettings";
import { routePaths } from "./route-paths";

/** The portfolio builder, or the dashboard where it is switched off, including for a saved link. */
export function RequirePortfolioBuilder() {
  const settings = usePortalSettings();

  if (settings.isPending) {
    return null;
  }

  return settings.data?.portfolioBuilderEnabled ? (
    <Outlet />
  ) : (
    <Navigate to={routePaths.dashboard} replace />
  );
}
